import { render, staticRenderFns } from "./five-must-play-golf-courses-in-pickering.vue?vue&type=template&id=47ed401c&scoped=true&"
import script from "./five-must-play-golf-courses-in-pickering.vue?vue&type=script&lang=js&"
export * from "./five-must-play-golf-courses-in-pickering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ed401c",
  null
  
)

export default component.exports